import { motion } from "framer-motion";
import { Crown, Percent, Lock, FileSignature } from "lucide-react";
import { Reveal, SectionLabel } from "./Reveal";

const Card = ({ className = "", children, testid, delay = 0 }) => (
  <Reveal delay={delay} className={`min-w-0 ${className}`}>
    <div data-testid={testid}
      className="group relative h-full overflow-hidden border border-teal-400/15 bg-[#0e131f] p-7 transition-colors duration-500 hover:border-amber-400/50 sm:p-8">
      <div className="pointer-events-none absolute -right-20 -top-20 h-48 w-48 rounded-full bg-amber-400/0 blur-3xl transition-colors duration-700 group-hover:bg-amber-400/15" />
      {children}
    </div>
  </Reveal>
);

const Tag = () => (
  <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-400">Placeholder · TBA</span>
);

const ALLOC = [["Liquidity pool", 80, "bg-amber-400"], ["Marketing", 10, "bg-teal-400"], ["CEO bonus jar", 10, "bg-slate-300"]];

export const Tokenomics = () => (
  <section id="tokenomics" className="relative py-24 sm:py-36" data-testid="tokenomics-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal><SectionLabel index="03">Annual report</SectionLabel></Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-6 font-display text-4xl font-bold uppercase leading-[0.95] sm:text-6xl">
          Token<span className="text-gold">omics</span>
        </h2>
      </Reveal>
      <div className="mt-16 grid grid-cols-1 gap-4 lg:auto-rows-fr md:grid-cols-6 lg:grid-cols-12">
        <Card className="md:col-span-6 lg:col-span-7 lg:row-span-2" testid="tokenomics-card-supply">
          <div className="flex h-full flex-col justify-between gap-10">
            <div className="flex items-center justify-between"><Crown className="h-8 w-8 text-amber-400" /><Tag /></div>
            <div>
              <p className="font-mono text-xs uppercase tracking-[0.3em] text-teal-300">Total supply</p>
              <p className="mt-3 break-words font-display text-[11vw] font-black leading-none text-gold sm:text-6xl xl:text-7xl">1,000,000,000</p>
              <p className="mt-4 text-slate-300">$OVERLORD. One supply. One boss. No stock options for employees.</p>
            </div>
          </div>
        </Card>
        <Card className="md:col-span-3 lg:col-span-5" testid="tokenomics-card-tax" delay={0.1}>
          <div className="flex items-center justify-between"><Percent className="h-6 w-6 text-teal-300" /><Tag /></div>
          <p className="mt-6 font-mono text-xs uppercase tracking-[0.3em] text-slate-400">Buy / Sell tax</p>
          <p className="mt-2 font-display text-4xl font-black text-slate-50">0% / 0%</p>
        </Card>
        <Card className="md:col-span-3 lg:col-span-5" testid="tokenomics-card-liquidity" delay={0.15}>
          <div className="flex items-center justify-between"><Lock className="h-6 w-6 text-teal-300" /><Tag /></div>
          <p className="mt-6 font-mono text-xs uppercase tracking-[0.3em] text-slate-400">Liquidity</p>
          <p className="mt-2 font-display text-4xl font-black text-slate-50">Burned</p>
        </Card>
        <Card className="md:col-span-6 lg:col-span-8" testid="tokenomics-card-allocation" delay={0.1}>
          <div className="flex items-center justify-between">
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-teal-300">Allocation</p><Tag />
          </div>
          <div className="mt-6 flex h-3 w-full overflow-hidden bg-slate-800">
            {ALLOC.map(([l, v, c], i) => (
              <motion.div key={l} className={c} initial={{ width: 0 }} whileInView={{ width: `${v}%` }}
                viewport={{ once: true }} transition={{ duration: 1.2, delay: 0.2 + i * 0.15, ease: [0.16, 1, 0.3, 1] }} />
            ))}
          </div>
          <div className="mt-6 grid grid-cols-3 gap-4">
            {ALLOC.map(([l, v, c]) => (
              <div key={l}>
                <div className="flex items-center gap-2"><span className={`h-2 w-2 ${c}`} /><span className="text-xs text-slate-400 sm:text-sm">{l}</span></div>
                <p className="mt-1 font-display text-2xl font-bold">{v}%</p>
              </div>
            ))}
          </div>
        </Card>
        <Card className="md:col-span-6 lg:col-span-4" testid="tokenomics-card-ownership" delay={0.15}>
          <div className="flex items-center justify-between"><FileSignature className="h-6 w-6 text-teal-300" /><Tag /></div>
          <p className="mt-6 font-mono text-xs uppercase tracking-[0.3em] text-slate-400">Contract</p>
          <p className="mt-2 font-display text-3xl font-black text-slate-50">Renounced</p>
          <p className="mt-2 text-sm text-slate-400">He signs nothing. He just points.</p>
        </Card>
      </div>
    </div>
  </section>
);
